import React from 'react'
import type { InlineInputProps, SelectProps } from '@ztechapps/webui.input'
import { TemplateSelectCreatable, TemplateSelectInlineInput } from '@ztechapps/webui.data-tools'
const templateCategory = 'logisticInstruction_template'
const placeholder = 'Select a logistic instruction.'

export const LogisticInstructionSelect = (props: SelectProps) => {
  return <TemplateSelectCreatable templateCategory={templateCategory} placeholder={placeholder} {...props} />
}

export const LogisticInstructionSelectInlineInput = ({ inputProps = {}, ...props }: InlineInputProps) => {
  return (
    <TemplateSelectInlineInput
      selectComponent={LogisticInstructionSelect}
      templateCategory={templateCategory}
      isMulti={true}
      inputProps={{
        ...inputProps,
        closeMenuOnSelect: false,
      }}
      {...props}
    />
  )
}
